import type { DonationFormValues } from '@/donationForm/types'

import { WithFormValues } from '@/form/ActionForm/Field/Field'
const DonationFormField = WithFormValues<DonationFormValues>()
export default DonationFormField
